import { call, put } from "redux-saga/effects";
import { API_METHODS, ENDPOINTS } from "../../../endpoint";
import { Actions } from "../../../constants/actionTypes";
import { apiRequest } from "../../../../Utils/axiosApi";

export function* apiSiteFiles(action) {
  try {
    const result = yield call(apiRequest, {
      method: API_METHODS.GET,
      url: `${ENDPOINTS.FILE_EXPLORER}/getFile?siteId=${action.data.siteId}&path=${action.data.path}&stagingDomainName=${action.data.stagingDomainName}`,
    });
    yield put({
      type: Actions.SET_SITE_FILES,
      data: result.data,
    });
    yield put({
      type: Actions.SET_FILE_EXPLORER_LOCATION,
      data: action.data.path,
    });

    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiDeleteSiteFiles(action) {
  try {
    const result = yield call(apiRequest, {
      method: API_METHODS.DELETE,
      url: `${ENDPOINTS.FILE_EXPLORER}/delete?siteId=${action.data.siteId}&path=${action.data.key}&stagingDomainName=${action.data.stagingDomainName}`,
    });

    if (result.isApiSuccessful) {
      action.meta?.onSuccess();
    } else {
      action.meta?.onError();
    }
    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiDownloadSiteFiles(action) {
  try {
    const result = yield call(apiRequest, {
      method: API_METHODS.GET,
      url: `${ENDPOINTS.FILE_EXPLORER}/download-file?siteId=${action.data.siteId}&fileName=${action.data.key}&stagingDomainName=${action.data.stagingDomainName}`,
    });
    if (result.isApiSuccessful) {
      action.meta?.onSuccess();
    } else {
      action.meta?.onError();
    }
    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiDownloadSiteFolder(action) {
  try {
    const result = yield call(apiRequest, {
      method: API_METHODS.GET,
      url: `${ENDPOINTS.FILE_EXPLORER}/downloadfolder?siteId=${action.data.siteId}&path=${action.data.key}&stagingDomainName=${action.data.stagingDomainName}`,
    });

    if (result.isApiSuccessful) {
      action.meta?.onSuccess();
    } else {
      action.meta?.onError();
    }
    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiUploadObject(data) {
  try {
    const result = yield call(apiRequest, {
      url: `/fileExplorer/uploadFileWithPermission`,
      method: "POST",
      data,
    });
    if (result.isApiSuccessful) {
      data.meta?.onSuccess();
    } else {
      data.meta?.onError();
    }
    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}
